import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  "data-testid": "station-required-check-line",
  class: "flex flex-col gap-1 text-left md:flex-row md:items-start md:gap-2"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-bold text-textPrimary md:min-w-[110px]" }, "Check no app", -1)
const _hoisted_3 = { class: "flex flex-col gap-1" }
const _hoisted_4 = { class: "flex flex-wrap items-center gap-1" }
const _hoisted_5 = {
  key: 0,
  class: "text-sm text-textPrimary"
}
const _hoisted_6 = { class: "flex flex-wrap items-center gap-1 text-xs text-gray-600" }
const _hoisted_7 = { "data-testid": "station-required-check-source" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "·", -1)

import { computed } from 'vue'

import LabelBadge from '@/components/designSystem/Badges/LabelBadge.vue'
import type { CheckMethod } from '@/constants/ds-attendance.constants'
import {
  buildStationCheckLine,
  type RequiredCheckPolicyRef,
  type RequiredCheckSource,
  type ScheduleCheckFlags
} from '@/utils/registrationCheck'


export default /*#__PURE__*/_defineComponent({
  __name: 'StationRequiredCheckLine',
  props: {
    requiredCheckSource: { default: null },
    requiredCheckPolicy: { default: null },
    requiredCheck: { type: [Boolean, null], default: null },
    requiredCheckMethod: { default: null },
    ourTeam: { type: [Boolean, null], default: null },
    scheduleFlags: { default: null },
    touchTarget: { type: Boolean, default: false }
  },
  emits: ["openPolicy"],
  setup(__props: any, { emit }) {

const props = __props;





const line = computed(() =>
  buildStationCheckLine({
    requiredCheckSource: props.requiredCheckSource,
    requiredCheckPolicy: props.requiredCheckPolicy,
    requiredCheck: props.requiredCheck,
    requiredCheckMethod: props.requiredCheckMethod,
    ourTeam: props.ourTeam,
    scheduleFlags: props.scheduleFlags
  })
)

return (_ctx: any,_cache: any) => {
  return (line.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(LabelBadge, {
              label: line.value.statusLabel,
              color: line.value.required ? 'green' : 'gray',
              size: "small",
              icon: null,
              "data-testid": "station-required-check-status"
            }, null, 8, ["label", "color"]),
            (line.value.methodLabel)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, "· " + _toDisplayString(line.value.methodLabel), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, _toDisplayString(line.value.sourceLabel), 1),
            _hoisted_8,
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["text-primary30 underline font-semibold", { 'min-h-[40px]': _ctx.touchTarget }]),
              "data-testid": "station-required-check-link",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('openPolicy')))
            }, _toDisplayString(line.value.linkLabel), 3)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})